import { dateTypePolicy } from "../typePolicies";

export default {
  Mutation: { fields: { serverDate: dateTypePolicy } },
  Query: { fields: { serverDate: dateTypePolicy } },
  Subscription: { fields: { serverDate: dateTypePolicy } },
  Voter: { fields: { createdAt: dateTypePolicy } },
};
